
<template>  
  <component :is="tag" v-on="$listeners" :class="[linkClass, customClasses]">
    <span class="link__content">
      <slot></slot>
    </span>
    <!-- <slot name="icon">
      <icon viewBox="0 0 24 24" size="30px" name="arrow_long_right"></icon>
    </slot> -->
  </component>
</template>

<script>
import Icon from '../basic/Icon.vue'

export default {
  components: {
    Icon
  },
  name: 'VLink',
  props: {
    primary: Boolean,
    secondary: Boolean,
    tertiary: Boolean,
    disabled: Boolean,
    customClasses: String,
    light: Boolean,
    tag: {
      type: String,
      default: 'a'
    }
  },
  computed: {
    linkClass () {
      return {
        'link link--primary': this.primary === true,
        'link link--secondary': this.secondary === true,
        'link link--tertiary': this.tertiary === true,
        'link--disabled': this.disabled,
        light: this.light
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .link .icon {
    display: none;
  }
  .link.link--primary .icon,
  .link.link--secondary .icon {
    display: inline-block;
  }
  .light {
    color: $color-white;
    .link__content::before {
      background-color: $color-white;
    }
    ::v-deep .icon {
      fill: $color-white
    }
  }
</style>
